var _classCallCheck = require("/codebuild/output/src1039780453/src/web/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/codebuild/output/src1039780453/src/web/node_modules/@babel/runtime/helpers/createClass.js");

var utils = require('./utils');

var OldValue = /*#__PURE__*/function () {
  "use strict";

  function OldValue(unprefixed, prefixed, string, regexp) {
    _classCallCheck(this, OldValue);

    this.unprefixed = unprefixed;
    this.prefixed = prefixed;
    this.string = string || prefixed;
    this.regexp = regexp || utils.regexp(prefixed);
  }
  /**
   * Check, that value contain old value
   */


  _createClass(OldValue, [{
    key: "check",
    value: function check(value) {
      if (value.includes(this.string)) {
        return !!value.match(this.regexp);
      }

      return false;
    }
  }]);

  return OldValue;
}();

module.exports = OldValue;